(() => {
  'use strict';

  document.addEventListener('modalOpened', (event) => {
    const modal = event.detail.modal;
    const isIPhone = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

    const input = modal && modal.querySelector('input[type="text"]');

    if (!input) {
      return;
    }

    if (input && input.value === '') {
      input.dataset.qaIsAutoFocus = 'true';
      input.focus();

      // this is required because on iPhone, when the keyboard is displayed, it pushes the modal up when
      // the input is focused, window.scroll(0,0) brings it back to its original position.
      if (isIPhone) {
        setTimeout(() => window.scrollTo(0, 0), 100);
      }
      return;
    }

    input.dataset.qaIsAutoFocus = 'false';
  });
})();
